import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack, Typography } from '@mui/material';
import { profileChangePasswordSchema } from 'common/schema';
import React from 'react';
import { useForm } from 'react-hook-form';
import FormProvider from 'common/components/form-provider';
import { colors, styleInput } from 'common/constants';
import avatarDefault from 'assets/images/icons/avatar-default.svg';
import { createStyleSheet, handleError } from 'utils/helpers';
import RequiredLabel from 'common/components/required-label';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { common } from '@mui/material/colors';
import { toast } from 'react-toastify';
import { ReactComponent as SyncIcon } from 'assets/images/icons/sync.svg';
import CloseIcon from '@mui/icons-material/Close';
import BaseTextPasswordField from 'common/components/base-text-password-field';
import { updatePassword } from 'services/user.service';

const ChangePassword = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const methods = useForm({
        resolver: yupResolver(profileChangePasswordSchema),
        defaultValues: {
            current_password: '',
            password: '',
            password_confirmation: '',
        },
    });
    const { handleSubmit, reset, setError } = methods;
    const onSubmit = handleSubmit(async (data) => {
        try {
            const response = await updatePassword(data);
            if (response.success) {
                toast.success(response.message);
            } else {
                Object.entries(response?.message).forEach(([key, value]) => {
                    setError(
                        key as
                            | 'current_password'
                            | 'password'
                            | 'password_confirmation',
                        {
                            type: 'manual',
                            message: value,
                        }
                    );
                });
            }
        } catch (error) {
            handleError(error);
        }
    });

    return (
        <Box
            sx={{
                marginTop: '2rem',
            }}
        >
            <Typography variant="h4" sx={styles.title}>
                Đổi mật khẩu
            </Typography>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <Box display={'flex'} gap={'60px'}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '37px',
                        }}
                    >
                        <Box>
                            <Stack spacing={'7px'}>
                                <RequiredLabel
                                    label={'Mật khẩu cũ'}
                                    required={false}
                                />
                                <BaseTextPasswordField
                                    autoComplete="off"
                                    name="current_password"
                                    fullWidth
                                    size="small"
                                    sx={styles.input}
                                />
                            </Stack>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                gap: '37px',
                            }}
                        >
                            <Stack spacing={'7px'}>
                                <RequiredLabel
                                    label={'Mật khẩu mới'}
                                    required={false}
                                />
                                <BaseTextPasswordField
                                    autoComplete="off"
                                    name="password"
                                    fullWidth
                                    size="small"
                                    sx={styles.input}
                                />
                            </Stack>
                            <Stack spacing={'7px'}>
                                <RequiredLabel
                                    label="Xác nhận mật khẩu mới"
                                    required={false}
                                />
                                <BaseTextPasswordField
                                    autoComplete="off"
                                    name="password_confirmation"
                                    fullWidth
                                    size="small"
                                    sx={styles.input}
                                />
                            </Stack>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '37px',
                            }}
                        >
                            <Stack spacing={'7px'}>
                                <Stack
                                    display={'flex'}
                                    flexDirection={'row'}
                                    gap={1}
                                >
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        sx={styles.btnEdit}
                                        startIcon={<SyncIcon />}
                                    >
                                        {t('common.update')}
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            navigate('/admin/profile');
                                            reset();
                                        }}
                                        startIcon={<CloseIcon />}
                                        sx={{
                                            ...styles.btnEdit,
                                            width: '155px',
                                            backgroundColor: common.white,
                                            border: `2px solid ${colors.main}`,
                                            ':hover': {
                                                backgroundColor: common.white,
                                                border: `2px solid ${colors.main}`,
                                            },
                                        }}
                                    >
                                        {t('common.close')}
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            </FormProvider>
        </Box>
    );
};

const styles = createStyleSheet({
    input: {
        '& .MuiInputBase-root': {
            ...styleInput['& .MuiInputBase-root'],
            width: '400px',
            height: '60px',
            fontSize: '22px',
        },
    },
    title: {
        fontSize: '40px',
        fontWeight: 700,
        color: colors.main,
        marginBottom: '27px',
    },
    avatar: {
        width: '348px',
        height: '348px',
        backgroundImage: `url(${avatarDefault})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        borderRadius: '17px',
        border: `2px dotted ${colors.main}`,
    },
    btnEdit: {
        width: '230px',
        height: '60px',
        fontSize: '20px',
        lineHeight: '24px',
        fontWeight: '700',
        borderRadius: '40px',
        textTransform: 'none',
    },
});

export default ChangePassword;
